export default "__VITE_ASSET__BqaX8ag$__"